// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Append an asterisk to required labels. The asterisk follows the label's text color */
.form-label.required::after,
.control-label.required::after {
  content: ' *';
  color: currentColor; /* inherit the label's color (e.g., danger, muted, etc.) */
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
